import React, { Component } from 'react';
import '../css/style.css';
import '../css/FbPlugin.css';
import fbScript from '../utils/fbjs.js'
//import IntroLogo from './IntroLogo.js';
//import introText from './texts/intro.txt';

function FbHeader(props){
        return (
          <div>
            {props.header?
                    <div className="text_header_container fb_header_container" >
                
                    <div className="text_header  fb_header" >
                        {props.header}
                    </div>
                    <div className='text_header_underline'></div>
                    </div>
            :''}
            {props.content?
                <div className="text_content" >
                {props.content}
                </div>
            :''}
          </div>
        );

}

export default FbHeader;


// WEBPACK FOOTER //
// ./src/Templates/FbHeader.js